import StudyGoalSelector from "@/components/shared/StudyGoalSelector";
import { useEffect, useState } from "react";
import { Const } from "snudbud-backbone-sdk";
import OnboardingLayout from "./OnboardingLayout";

interface StudyGoalStepProps {
  onContinue: (goal: Const.DailyGoal) => void;
  initialValue: Const.DailyGoal;
}

export default function StudyGoalStep({ onContinue, initialValue }: StudyGoalStepProps) {
  const [selectedGoal, setSelectedGoal] = useState<Const.DailyGoal>(initialValue || "medium");

  // Set default value to "committed" if initialValue is not set
  useEffect(() => {
    if (!initialValue) setSelectedGoal("medium");
  }, [initialValue]);

  return (
    <OnboardingLayout
      title="That's great! What's your daily study goal?"
      onContinue={() => onContinue(selectedGoal)}
      step={3}
      totalSteps={5}
    >
      <StudyGoalSelector selectedGoal={selectedGoal} onChange={setSelectedGoal} />
    </OnboardingLayout>
  );
}
